export default "__VITE_ASSET__1e7W0h9V__"